import { REFERRAL_CODE_ALPHABET } from '../constants';

export function getGeneralReferralOg(): { title: string; description: string } {
	return {
		title: "I'm playing on SportsPredict.com!",
		description: 'Join the action and start making your picks.',
	};
}

export function getLobbyInviteOg(
	lobbyName: string,
	eventName: string
): { title: string; description: string } {
	return {
		title: `Join me in ${lobbyName} Lobby!`,
		description: `Compete in ${eventName} Prediction Game.`,
	};
}

export function getGeneralReferralMessage(): string {
	const { title, description } = getGeneralReferralOg();

	return `${title}
${description}

Click this link to sign up!`;
}

export function getLobbyInviteMessage(lobbyName: string, eventName: string): string {
	return `Join me in ${lobbyName} Lobby as I Compete in ${eventName} Prediction Game.

Click this link to join!`;
}

export function isValidReferralCode(code: string) {
	if (!code) return false;

	const parts = code.toUpperCase().split('-');

	if (parts.length !== 2) return false;

	const [base, checksum] = parts;

	if (base.length !== 6) return false;

	for (const char of base) {
		if (!REFERRAL_CODE_ALPHABET.includes(char)) return false;
	}

	let sum = 0;

	for (let i = 0; i < base.length; i++) {
		sum += REFERRAL_CODE_ALPHABET.indexOf(base[i]) * (i + 1);
	}

	const expected = REFERRAL_CODE_ALPHABET[sum % REFERRAL_CODE_ALPHABET.length];

	return expected === checksum;
}
